var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.9999789 6-7.9999789 4.3333194 2.90909053 1.5744677v4.3333194l5.09088837 2.7588935 5.0909264-2.7588935v-4.3333194l1.4545262-.7872129v4.9905323h1.4545685v-5.7777871zm4.9600595 4.3333194-4.9600173 2.6866806-4.95998352-2.6866806 4.95998352-2.68665553zm-4.9600595 7.02 3.6364001-1.9716388v-2.6866806l-3.6364001 1.9716806-3.63635789-1.9716806v2.6866806z",
    fill: "current",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.51e8c5a457f7ca83a267c0aa5459ed87.svg";
export { ForwardRef as ReactComponent };